<template>
  <div v-loading="state.loading">
    <page-title title="Создание нового свойства">
      <el-button type="primary" @click="save">Сохранить</el-button>
    </page-title>

    <property-form :property="property"/>

  </div>
</template>

<script>

  import {post} from '@/modules/settings/components/Properties/api'
  import PropertyTypes from './types'
  import form from './form'

  export default {
    components: {PropertyForm: form},
    data: () => ({
      property: {
        required: false,
        type: 'string',
        name: '',
        unit: false,
      },
      state: {
        loading: false
      },
      types: PropertyTypes
    }),
    methods: {
      save() {
        if (!this.property.name.length) {
          this.$message.error('Заполните название свойства')
        }

        let data = {...this.property}

        if (this.property.type === 'select') {
          let options = this.property.selectOptions.map(option => option.name)
          data.select = JSON.stringify(options)
          let defaultOption = this.property.selectOptions.find(option => option.default)

          if (defaultOption) {
            data.default = defaultOption.name
          }
        }
        delete this.property.selectOptions

        if (data.default && data.default.length) {
          data.default += ''
        } else {
          delete data.default
        }

        this.state.loading = true

        post(data).then(response => {
          response.log
          this.$message.success('Свойство успешно создано')
          this.$router.push({name: 'Properties.list'})
        }).catch(error => {
          this.state.loading = false
          this.$message.error('Ошибка при создании свойства')
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/modules/settings/components/Properties/create.vue